import { useState } from "react";
import { SignUpModal } from "./SignUpModal";
import { Building2, Users, Briefcase, Search, Lightbulb } from "lucide-react";
const TABS = [{
  id: "early-stage",
  label: "Early-Stage Companies",
  sublabel: "Funding Application",
  icon: Building2,
  description: "Get the support and resources you need to grow your startup"
}, {
  id: "portfolio",
  label: "Portfolio Company Log In",
  icon: Users,
  description: "Access your portfolio dashboard and management tools"
}, {
  id: "seed-angel",
  label: "Seed / Angel Fund Log In",
  icon: Briefcase,
  description: "Manage your fund investments and track performance"
}, {
  id: "investor",
  label: "Investor - Search Startups",
  icon: Search,
  description: "Discover promising startups ready for investment"
}, {
  id: "industry",
  label: "Industry - Search Innovation",
  icon: Lightbulb,
  description: "Explore cutting-edge innovation across industries"
}, {
  id: "services",
  label: "Early-Stage Resources Search & Service Request",
  icon: Lightbulb,
  description: "Explore cutting-edge innovation across industries"
}];
export function PublicHome() {
  const [activeTab, setActiveTab] = useState("early-stage");
  const [showSignUp, setShowSignUp] = useState(false);
  const handleSignUp = (formData: any) => {
    console.log("Sign up data:", formData);
    // Handle sign up logic here
    setShowSignUp(false);
  };
  return <div className="min-h-screen w-full">
    {/* Hero Section */}
    <div className="bg-gradient-to-r from-[#1D31FF] to-purple-600 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl">
          <h1 className="text-4xl font-bold mb-4">
            Enabling and Optimizing Connections Across the Michigan Innovation
            Ecosystem
          </h1>
          <ul className="list-disc pl-5 text-xl text-white/90 mb-8">
            <li>Michigan startups looking for funding</li>
            <li>Supporting existing portfolio companies by connecting them with new investors and potential customers</li>
            <li>Enabling follow-on investors to review and research portfolio companies raising rounds</li>
            <li>Innovation search and connection tool for industry partners</li>
            <li>Streamlining reporting systems across the state</li>
          </ul>
        </div>
      </div>
    </div>
    {/* Main Content */}
    <div className="container mx-auto px-4 py-12">
      <div className="flex flex-col md:flex-row gap-8">
        {/* Tabs Navigation - Now with background card */}
        <div className="md:w-64 flex-shrink-0">
          <div className="bg-white rounded-xl shadow-lg p-4">
            <div className="space-y-2">
              {TABS.map(tab => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full flex items-center gap-3 p-4 rounded-lg text-left transition-colors ${activeTab === tab.id ? "bg-[#1D31FF] text-white" : "hover:bg-gray-50 text-gray-700"}`}
                  >
                    <Icon className="h-5 w-5" />
                    <div className="flex flex-col">
                      <span className="font-medium">{tab.label}</span>
                      {tab.sublabel && (
                        <span className="text-sm">{tab.sublabel}</span>
                      )}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        {/* Tab Content */}
        <div className="flex-1">
          <div className="bg-white rounded-xl shadow-lg p-6">
            {/* Early Stage Companies */}
            {activeTab === "early-stage" && <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Early-Stage Company Pre-Seed Investment Application
              </h2>
              <p className="text-gray-600 mb-6">
                Start-up companies looking for early-stage investment can submit a company profile, pitchdeck, and overview video.
              </p>
              <p className="text-gray-600 mb-6">
                This information can be sent out to all of Michigna's pre-seed inveatment funds and multiple angel funds - streamlining the outreach process through a single profile submittal.
              </p>
              <div className="grid md:grid-cols-2 gap-6">
                {/* Feature cards */}
                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-medium text-gray-900 mb-2">
                    Funding
                  </h3>
                  <p className="text-gray-600">
                    Access our network of investors and funding
                    opportunities
                  </p>
                </div>
                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-medium text-gray-900 mb-2">
                    Services / Resources
                  </h3>
                  <p className="text-gray-600">
                    Get tools and resources to build and scale your startup
                  </p>
                </div>
              </div>
            </div>}
            {/* Portfolio Companies */}
            {activeTab === "portfolio" && <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Portfolio Company Dashboard
              </h2>
              <p className="text-gray-600 mb-6">
                Review and update your company profile.
              </p>
              <p className="text-gray-600 mb-6">
                Create or update a fundraising summary (target raise, pitchdeck, dataroom link, overview video)
              </p>
              <p className="text-gray-600 mb-6">
                Optimize your technology/innovation showcase for first/next customer engagements
              </p>
              <button className="px-4 py-2 bg-[#1D31FF] text-white rounded-lg hover:bg-[#1D31FF]/90">
                Log In to Dashboard
              </button>
            </div>}
            {/* Portfolio Companies */}
            {activeTab === "seed-angel" && <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Pre-Seed and Angel Fund
              </h2>
              <p className="text-gray-600 mb-6">
                Update your profile, investment thesis, and contact information
              </p>
              <p className="text-gray-600 mb-6">
                Add new portfolio company invesetments and invite founders to update their profile.
              </p>
              <p className="text-gray-600 mb-6">
                Review and process your portfolio company reports for the MEDC / State of Michigan
              </p>
              <p className="text-gray-600 mb-6">
                Explore 500+ existing Michigan pre-seed and angel backed portfolio companies
              </p>
            </div>}
            {activeTab === "investor" && <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Investors
              </h2>
              <p className="text-gray-600 mb-6">
                Search, review, and connect with 500+ Michigan early-stage companies
              </p>
              {/* Bullet Point List */}
              <ul className="list-disc pl-5 text-gray-600 mb-6">
                <li>Company Profiles</li>
                <li>Pitchdecks</li>
                <li>Datarooms</li>
                <li>Pitch and Overview Videos</li>
              </ul>
              <p className="text-gray-600 mb-6">
                Searchable by sector, stage/raise, existing invtors, keyword tags, etc.
              </p>
            </div>}
            {activeTab === "industry" && <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Business and Industry
              </h2>
              <p className="text-gray-600 mb-6">
                Search and review innovation and technologies across 500+ early-stage companies.
              </p>
              <p className="text-gray-600 mb-6">
                Initiate contact directly or confidentially through the platform's communication portal
              </p>
              <p className="text-gray-600">
                Submit a statewide search for an innovation or technology gap/need to be shared across Michigan's Innovation ecosytem, including:
              </p>
              <ul className="list-disc pl-5 text-md text-gray-600 mb-8">
                <li>Universities, accelerators, and the start-up community</li>
                <li>Sector specialists and other ecosystem partners</li>
                <li>Submissions can remain confidential, allowing you to explore potential solutions while keeping your identity private through the platform</li>
              </ul>
              <button className="px-4 py-2 bg-[#1D31FF] text-white rounded-lg hover:bg-[#1D31FF]/90">
                Search Portal
              </button>
              <button className="px-4 py-2 bg-[#1D31FF] text-white rounded-lg hover:bg-[#1D31FF]/90 ml-4">
                Submit Innovation Gap
              </button>
            </div>}
          </div>
        </div>
      </div>
    </div>
    {showSignUp && <SignUpModal onClose={() => setShowSignUp(false)} onSignUp={handleSignUp} />}
  </div>;
}